import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, ViewChild, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { ExcelOrderImport_ShellService, EModalSize, EToasterType, EToasterPosition } from './ExcelOrderImport.shell.service';
import { ExcelOrderImport_OperationService } from './ExcelOrderImport.operation.service';
import { ExcelOrderImport_DatasourceService } from './ExcelOrderImport.datasource.index';
import { ExcelOrderImport_FlowService } from './ExcelOrderImport.flow.index';
import { ExcelOrderImport_ReportService } from './ExcelOrderImport.report.index';
import { ExcelOrderImport_LocalizationService } from './ExcelOrderImport.localization.service';
import { Language } from './localization.service';
import { $types } from './ExcelOrderImport.types'
import { ExcelOrderImport_receiving_shipping_dd_singleComponent } from './ExcelOrderImport.receiving_shipping_dd_single.component'
import { ExcelOrderImport_warehouses_dd_singleComponent } from './ExcelOrderImport.warehouses_dd_single.component'
import { ExcelOrderImport_projects_dd_singleComponent } from './ExcelOrderImport.projects_dd_single.component'
import { ExcelOrderImport_materials_by_project_dd_singleComponent } from './ExcelOrderImport.materials_by_project_dd_single.component'
import { ExcelOrderImport_material_packagings_dd_singleComponent } from './ExcelOrderImport.material_packagings_dd_single.component'
import { ExcelOrderImport_vendorLots_dd_singleComponent } from './ExcelOrderImport.vendorLots_dd_single.component'
import { ExcelOrderImport_lots_dd_singleComponent } from './ExcelOrderImport.lots_dd_single.component'


interface IExcelOrderImport_excel_portal_order_import_gridComponentEntity {
OrderId?: number, LineNumber?: number, LicensePlateId?: number, LotId?: number, MaterialId?: number, Notes?: string, PackagedAmount?: number, PackagedId?: number, SerialNumberId?: number, ShipmentId?: number, VendorLotId?: number, Order?: { LookupCode?: string, OrderClassId?: number, OwnerReference?: string, PreferredWarehouseId?: number, ProjectId?: number, VendorReference?: string, Addresses?: { Id?: number, City?: string, Country?: string, FirstName?: string, LastName?: string, Line1?: string, Line2?: string, LookupCode?: string, Name?: string, PostalCode?: string, PrimaryTelephone?: string, State?: string }[], PreferredWarehouse?: { Id?: number, Name?: string }, Project?: { Id?: number, LookupCode?: string }, OrderClass?: { OrderClassTypeId?: number } }, Material?: { Id?: number, LookupCode?: string }, Lot?: { Id?: number, LookupCode?: string }, VendorLot?: { Id?: number, LookupCode?: string }, LicensePlate?: { Id?: number, LookupCode?: string }, SerialNumber?: { Id?: number, LookupCode?: string }, InventoryMeasurementUnit?: { Id?: number, ShortName?: string }}

interface IExcelOrderImport_excel_portal_order_import_gridComponentInParams {
  projectId?: number, warehouseId?: number}


class ExcelOrderImport_excel_portal_order_import_gridComponentRowModel extends GridRowModel {
  grid: ExcelOrderImport_excel_portal_order_import_gridComponent;
  entity: IExcelOrderImport_excel_portal_order_import_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    type_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    vendor_reference_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    reference_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    warehouse_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    project_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    material_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    packaging_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    quantity_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    vendor_lot_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    lot_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    first_name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    last_name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    line1_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    line2_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    city_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    state_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    zip_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    country_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    phone_number_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    line_notes_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    order_id: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    line_number: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    error: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    type: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new SelectBoxModel(
        this.formGroup.controls['type_edit'] as DatexFormControl, 
        null, null,
        true, 
        '')
      ),
    vendor_reference: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['vendor_reference_edit'] as DatexFormControl, null, false, '')
      ),
    reference: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['reference_edit'] as DatexFormControl, null, false, '')
      ),
    warehouse: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new SelectBoxModel(
        this.formGroup.controls['warehouse_edit'] as DatexFormControl, 
        null, null,
        false, 
        '')
      ),
    project: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new SelectBoxModel(
        this.formGroup.controls['project_edit'] as DatexFormControl, 
        null, null,
        true, 
        '')
      ),
    material: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new SelectBoxModel(
        this.formGroup.controls['material_edit'] as DatexFormControl, 
        null, null,
        false, 
        '')
      ),
    packaging: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new SelectBoxModel(
        this.formGroup.controls['packaging_edit'] as DatexFormControl, 
        null, null,
        false, 
        '')
      ),
    quantity: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new NumberBoxModel(this.formGroup.controls['quantity_edit'] as DatexFormControl, null, false, '0', '')
      ),
    vendor_lot: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new SelectBoxModel(
        this.formGroup.controls['vendor_lot_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false, 
        '')
      ),
    lot: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new SelectBoxModel(
        this.formGroup.controls['lot_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false, 
        '')
      ),
    first_name: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['first_name_edit'] as DatexFormControl, null, false, '')
      ),
    last_name: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['last_name_edit'] as DatexFormControl, null, false, '')
      ),
    line1: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['line1_edit'] as DatexFormControl, null, false, '')
      ),
    line2: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['line2_edit'] as DatexFormControl, null, false, '')
      ),
    city: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['city_edit'] as DatexFormControl, null, false, '')
      ),
    state: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['state_edit'] as DatexFormControl, null, false, '')
      ),
    zip: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['zip_edit'] as DatexFormControl, null, false, '')
      ),
    country: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['country_edit'] as DatexFormControl, null, false, '')
      ),
    phone_number: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['phone_number_edit'] as DatexFormControl, null, false, '')
      ),
    line_notes: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['line_notes_edit'] as DatexFormControl, null, false, '')
      ),
  }

  get $fields_warehouse_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_project_selector_inParams_statusId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_material_selector_inParams_projectId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.utils;
    const $grid = this.grid;
    const expr = $row.cells.project.editControl.value;
    
    return expr;
  }
  get $fields_packaging_selector_inParams_materialId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.utils;
    const $grid = this.grid;
    const expr = $row.cells.material.editControl.value;
    
    return expr;
  }
  get $fields_vendor_lot_selector_inParams_materialId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.utils;
    const $grid = this.grid;
    const expr = $row.cells.material.editControl.value;
    
    return expr;
  }
  get $fields_lot_selector_inParams_materialId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.utils;
    const $grid = this.grid;
    const expr = $row.cells.material.editControl.value;
    
    return expr;
  }


  constructor(
    private utils: UtilsService,
private settings: SettingsValuesService,
private shell: ExcelOrderImport_ShellService,
private datasources: ExcelOrderImport_DatasourceService,
private flows: ExcelOrderImport_FlowService,
private reports: ExcelOrderImport_ReportService,
private localization: ExcelOrderImport_LocalizationService,
private operations: ExcelOrderImport_OperationService,
) {
    super();
    
    this.formGroup
      .controls['material_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_material_change();
      });
    this.formGroup
      .controls['vendor_lot_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_vendor_lot_change();
      });
  }

  async $initializeExisting(grid: ExcelOrderImport_excel_portal_order_import_gridComponent, entity: IExcelOrderImport_excel_portal_order_import_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.entity = entity;

    this.rowId = [this.entity.OrderId,this.entity.LineNumber].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(grid: ExcelOrderImport_excel_portal_order_import_gridComponent, entity?: IExcelOrderImport_excel_portal_order_import_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
      await this.on_init_new_row();
    }

    this.rowId = [this.entity.OrderId,this.entity.LineNumber].join('-');
    this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    const $resultKey = {};
    set($resultKey, 'OrderId',this.entity.OrderId);
    set($resultKey, 'LineNumber',this.entity.LineNumber);
    const inParams = {
      $keys:[$resultKey],
      projectId:  $grid.vars.projectId ,
    };
    const data = await this.datasources.ExcelOrderImport.ds_order_import_grid.getByKeys(inParams);
    this.entity = data.result[0];
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    (this.cells.order_id.displayControl as TextModel).text = $row.entity?.OrderId?.toString();
    (this.cells.line_number.displayControl as TextModel).text = $row.entity?.LineNumber?.toString();
    (this.cells.type.displayControl as TextModel).text = $row.entity?.Order?.OrderClass?.OrderClassTypeId == 1 ? 'Receiving' : 'Shipping';
    (this.cells.type.editControl as SelectBoxModel).reset($row.entity?.Order?.OrderClass?.OrderClassTypeId == 1 ? 1 : 2);
    (this.cells.vendor_reference.displayControl as TextModel).text = $row.entity?.Order?.VendorReference;
    (this.cells.vendor_reference.editControl as TextBoxModel).reset($row.entity?.Order?.VendorReference);
    (this.cells.reference.displayControl as TextModel).text = $row.entity?.Order?.OwnerReference;
    (this.cells.reference.editControl as TextBoxModel).reset($row.entity?.Order?.OwnerReference);
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.Order?.PreferredWarehouse?.Name;
    (this.cells.warehouse.editControl as SelectBoxModel).reset($row.entity.Order?.PreferredWarehouseId);
    (this.cells.project.displayControl as TextModel).text = $row.entity.Order?.Project?.LookupCode;
    (this.cells.project.editControl as SelectBoxModel).reset($row.entity.Order?.ProjectId);
    (this.cells.material.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.material.editControl as SelectBoxModel).reset($row.entity.MaterialId);
    (this.cells.packaging.displayControl as TextModel).text = $row.entity.InventoryMeasurementUnit?.ShortName;
    (this.cells.packaging.editControl as SelectBoxModel).reset($row.entity.PackagedId);
    (this.cells.quantity.displayControl as TextModel).text = $row.entity?.PackagedAmount?.toString();
    (this.cells.quantity.editControl as NumberBoxModel).reset($row.entity?.PackagedAmount);
    (this.cells.vendor_lot.displayControl as TextModel).text = $row.entity.VendorLot?.LookupCode;
    (this.cells.lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.lot.editControl as SelectBoxModel).reset($row.entity.Lot?.Id);
    (this.cells.first_name.displayControl as TextModel).text = $row.entity.Order?.Addresses[0]?.FirstName;
    (this.cells.first_name.editControl as TextBoxModel).reset($row.entity.Order?.Addresses[0]?.FirstName);
    (this.cells.last_name.displayControl as TextModel).text = $row.entity.Order?.Addresses[0]?.LastName;
    (this.cells.last_name.editControl as TextBoxModel).reset($row.entity.Order?.Addresses[0]?.LastName);
    (this.cells.line1.displayControl as TextModel).text = $row.entity.Order?.Addresses[0]?.Line1;
    (this.cells.line1.editControl as TextBoxModel).reset($row.entity.Order?.Addresses[0]?.Line1);
    (this.cells.line2.displayControl as TextModel).text = $row.entity.Order?.Addresses[0]?.Line2;
    (this.cells.line2.editControl as TextBoxModel).reset($row.entity.Order?.Addresses[0]?.Line2);
    (this.cells.city.displayControl as TextModel).text = $row.entity.Order?.Addresses[0]?.City;
    (this.cells.city.editControl as TextBoxModel).reset($row.entity.Order?.Addresses[0]?.City);
    (this.cells.state.displayControl as TextModel).text = $row.entity.Order?.Addresses[0]?.State;
    (this.cells.state.editControl as TextBoxModel).reset($row.entity.Order?.Addresses[0]?.State);
    (this.cells.zip.displayControl as TextModel).text = $row.entity.Order?.Addresses[0]?.PostalCode;
    (this.cells.zip.editControl as TextBoxModel).reset($row.entity.Order?.Addresses[0]?.PostalCode);
    (this.cells.country.displayControl as TextModel).text = $row.entity.Order?.Addresses[0]?.Country;
    (this.cells.country.editControl as TextBoxModel).reset($row.entity.Order?.Addresses[0]?.Country);
    (this.cells.phone_number.displayControl as TextModel).text = $row.entity.Order?.Addresses[0]?.PrimaryTelephone;
    (this.cells.phone_number.editControl as TextBoxModel).reset($row.entity.Order?.Addresses[0]?.PrimaryTelephone);
    (this.cells.line_notes.displayControl as TextModel).text = $row.entity.Notes;
    (this.cells.line_notes.editControl as TextBoxModel).reset($row.entity.Notes);

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save_new_row();
      this.isNew = false;
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_init_new_row(event = null) {
    return this.on_init_new_rowInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_init_new_rowInternal(
    $row: ExcelOrderImport_excel_portal_order_import_gridComponentRowModel,
  $grid: ExcelOrderImport_excel_portal_order_import_gridComponent, 
    $shell: ExcelOrderImport_ShellService,
    $datasources: ExcelOrderImport_DatasourceService,
    $flows: ExcelOrderImport_FlowService,
    $reports: ExcelOrderImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelOrderImport_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelOrderImport_LocalizationService,
    $event: any
  ) {
  const nextId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Order" })).nextId;
  
  
  $row.entity = {
      OrderId: nextId
  };
  
  // Initialize read only cells if a user manually adds a new row.
   $row.cells.type.editControl.readOnly = false;
   $row.cells.warehouse.editControl.readOnly = false;
   $row.cells.project.editControl.readOnly = false;
   $row.cells.material.editControl.readOnly = false;
   $row.cells.packaging.editControl.readOnly = false;
   $row.cells.quantity.editControl.readOnly = false;
  
  
  
  
  
  
  }
  on_material_change(event = null) {
    return this.on_material_changeInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_material_changeInternal(
    $row: ExcelOrderImport_excel_portal_order_import_gridComponentRowModel,
  $grid: ExcelOrderImport_excel_portal_order_import_gridComponent, 
    $shell: ExcelOrderImport_ShellService,
    $datasources: ExcelOrderImport_DatasourceService,
    $flows: ExcelOrderImport_FlowService,
    $reports: ExcelOrderImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelOrderImport_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelOrderImport_LocalizationService,
    $event: any
  ) {
  $row.cells.packaging.editControl.value = null;
  $row.cells.lot.editControl.value = null;
  $row.cells.vendor_lot.editControl.value = null;
  }
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: ExcelOrderImport_excel_portal_order_import_gridComponentRowModel,
  $grid: ExcelOrderImport_excel_portal_order_import_gridComponent, 
    $shell: ExcelOrderImport_ShellService,
    $datasources: ExcelOrderImport_DatasourceService,
    $flows: ExcelOrderImport_FlowService,
    $reports: ExcelOrderImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelOrderImport_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelOrderImport_LocalizationService,
    $event: any
  ) {
  const allRequiredFieldHaveValue = $utils.isAllDefined(
      $row.cells.project.editControl.value,
      $row.cells.warehouse.editControl.value,
      $row.cells.material.editControl.value,
      $row.cells.packaging.editControl.value,
      $row.cells.quantity.editControl.value
  );
  
  if (allRequiredFieldHaveValue === false) {
      $shell.ExcelOrderImport.openErrorDialog('Save', 'Missing Required fields');
      throw new Error('Missing Required fields'); // to prevent displayMode 
  }
  
  var errors = '';
  var orders = (await $datasources.ExcelOrderImport.ds_get_order_by_orderId.get({
      orderId: $row.entity.OrderId
  })).result;
  
  
  
  const payloadOrder: any = {};
  
  if ($row.cells.vendor_reference.editControl.isChanged) {
      payloadOrder.VendorReference = $row.cells.vendor_reference.editControl.value;
  }
  if ($row.cells.reference.editControl.isChanged) {
      payloadOrder.OwnerReference = $row.cells.reference.editControl.value;
  }
  
  const orderLinepayload: any = {};
  if ($row.cells.quantity.editControl.isChanged) {
      orderLinepayload.PackagedAmount = $row.cells.quantity.editControl.value;
  }
  if ($row.cells.material.editControl.isChanged) {
      orderLinepayload.MaterialId = $row.cells.material.editControl.value;
  }
  if ($row.cells.packaging.editControl.isChanged) {
      orderLinepayload.PackagedId = $row.cells.packaging.editControl.value;
  }
  if ($row.cells.line_notes.editControl.isChanged) {
      orderLinepayload.Notes = $row.cells.line_notes.editControl.value;
  }
  
  let payloadOrderAddress: any = {};
  
  if ($row.cells.first_name?.editControl.isChanged) {
      payloadOrderAddress.Name = $row.cells.first_name?.editControl.value;
      payloadOrderAddress.FirstName = $row.cells.first_name?.editControl.value;
  }
  if ($row.cells.last_name?.editControl.isChanged) {
      payloadOrderAddress.LastName = $row.cells.last_name?.editControl.value;
  }
  if ($row.cells.line1?.editControl.isChanged) {
      payloadOrderAddress.Line1 = $row.cells.line1?.editControl.value;
  }
  if ($row.cells.line2?.editControl.isChanged) {
      payloadOrderAddress.Line2 = $row.cells.line2?.editControl.value;
  }
  if ($row.cells.city?.editControl.isChanged) {
      payloadOrderAddress.City = $row.cells.city?.editControl.value;
  }
  if ($row.cells.state?.editControl.isChanged) {
      payloadOrderAddress.State = $row.cells.state?.editControl.value;
  }
  if ($row.cells.country?.editControl.isChanged) {
      payloadOrderAddress.Country = $row.cells.country?.editControl.value;
  }
  if ($row.cells.zip?.editControl.isChanged) {
      payloadOrderAddress.PostalCode = $row.cells.zip?.editControl.value;
  }
  if ($row.cells.phone_number?.editControl.isChanged) {
      payloadOrderAddress.PrimaryTelephone = $row.cells.phone_number?.editControl.value;
  }
  
  try {
      await $flows.Utilities.crud_update_flow({ entitySet: 'Orders', id: $row.entity.OrderId, entity: payloadOrder });
      await $flows.Utilities.crud_update_dual_pk_flow({
          entitySet: 'OrderLines',
          pk1String: 'OrderId',
          pk1: $row.entity.OrderId,
          pk2String: 'LineNumber',
          pk2: $row.entity.LineNumber,
          entity: orderLinepayload
      });
  
      //Bug Wavelength 153604: Excel Order Import - Cannot read properties exception when order is not provided on the import
      if ($utils.isDefined($row.entity.Order.Addresses)) {
          await $flows.Utilities.crud_update_flow({ entitySet: 'OrderAddresses', id: $row.entity.Order.Addresses[0].Id, entity: payloadOrderAddress });
      };
  
      var orderId = $row.entity.OrderId;
  
      if ($utils.isDefined(payloadOrder) || $utils.isDefined(payloadOrderAddress)) {
          for (const OrderLine of $grid.rows) {
              if (OrderLine.entity.OrderId == orderId) {
                  await OrderLine.refresh();
              };
          };
      } else {
          await $row.refresh();
      };
  } catch (error) {
      $shell.ExcelOrderImport.showErrorDetails('Save', 'Error on save.', error);
      throw error; // to prevent displayMode 
  }
  
  }
  on_save_new_row(event = null) {
    return this.on_save_new_rowInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_new_rowInternal(
    $row: ExcelOrderImport_excel_portal_order_import_gridComponentRowModel,
  $grid: ExcelOrderImport_excel_portal_order_import_gridComponent, 
    $shell: ExcelOrderImport_ShellService,
    $datasources: ExcelOrderImport_DatasourceService,
    $flows: ExcelOrderImport_FlowService,
    $reports: ExcelOrderImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelOrderImport_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelOrderImport_LocalizationService,
    $event: any
  ) {
  const allRequiredFieldHaveValue = $utils.isAllDefined(
      $row.cells.project.editControl.value,
      $row.cells.warehouse.editControl.value,
      $row.cells.material.editControl.value,
      $row.cells.packaging.editControl.value,
      $row.cells.quantity.editControl.value
  );
  
  
  if (allRequiredFieldHaveValue === false) {
      $shell.ExcelOrderImport.openErrorDialog('Save', 'Missing Required fields');
      throw new Error('Missing Required fields'); // to prevent displayMode 
  } else {
  
      try {
  
          var candidate = [];
          candidate.push({ row: $row });
  
          // Initialize data
          var errors = ''
  
          var warehousesCandidates = candidate.filter(ol => $utils.isDefinedTrimmed(ol.row.cells.warehouse.editControl.value)).map(ol => ol.row.cells.warehouse.editControl.value);
          var projectsCandidate = candidate.filter(ol => $utils.isDefinedTrimmed(ol.row.cells.project.editControl.value)).map(ol => ol.row.cells.project.editControl.value);
          var orderTypesCandidates = candidate.filter(ol => $utils.isDefinedTrimmed((ol.row.cells.type.editControl.value === 1 ? 'Inbound' : 'Outbound'))).map(ol => (ol.row.cells.type.editControl.value === 1 ? 'Inbound' : 'Outbound'));
  
  
          if ($row.cells.type.editControl.value == 1) {
              var orderTypeId = 1;
          }
          if ($row.cells.type.editControl.value == 2) {
              var orderTypeId = 2;
          }
  
  
  
  
          // create related header entities and order line
          const orderId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Order" })).nextId;
          const nextShipmentId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Shipment" })).nextId;
          const nextAccountId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Account" })).nextId;
          const nextContactId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Contact" })).nextId;
          const nextAddressId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Address" })).nextId;
  
  
  
          const payloadAccount = {
              "Id": nextAccountId,
              "EnterpriseId": 1,
              "TypeId": 4,
              "LookupCode": "ord-" + orderId,
              "Name": "ord-" + orderId,
              "Active": true,
              "AllocationPriority": 0,
              "AllowReceiving": false,
              "AllowShipping": false,
              "AllowReturnsIn": false,
              "RequiresReceivingRma": false,
              "TaxScheduleId": 0,
              "RequiresShippingRma": false
          };
  
          const payloadContacts = {
              "Id": nextContactId,
              "OwnerEntity": "Account",
              "OwnerId": nextAccountId,
              "TypeId": 2,
              "Address": {
                  "Id": nextAddressId,
                  "Line1": "ord-" + orderId
              },
              "FirstName": "ord-" + orderId,
              "LastName": "ord-" + orderId
          };
  
          const shipmentpayload = {
              "Order": {
                  "Id": orderId,
                  "OrderStatusId": 1,
                  "ReadyToExport": false,
                  "AccountId": nextAccountId,
                  "BillingAddresId": nextAddressId,
                  "Exported": false,
                  "LookupCode": orderId.toString(),
                  "OrderClassId": orderTypeId,
                  "ProjectId": $row.cells.project.editControl.value,
                  "PreferredWarehouseId": $row.cells.warehouse.editControl.value,
                  "OwnerReference": $row.cells.reference.editControl.value,
                  "VendorReference": $row.cells.vendor_reference.editControl.value
              },
              "Shipment": {
                  "Id": nextShipmentId,
                  "LookupCode": orderId.toString(),
                  "AccountId": nextAccountId,
                  "ContactId": nextContactId,
                  "ExpectedWarehouseId": $row.cells.warehouse.editControl.value,
                  "Cartonized": false,
                  "ConfirmSeal": false,
                  "StatusId": 1,
                  "Transhipment": false,
                  "TypeId": orderTypeId
              }
          };
  
          await $flows.Utilities.crud_create_flow({ entitySet: 'Accounts', entity: payloadAccount });
          await $flows.Utilities.crud_create_flow({ entitySet: 'Contacts', entity: payloadContacts });
          await $flows.Utilities.crud_create_flow({ entitySet: 'ShipmentOrderLookup', entity: shipmentpayload });
  
  
          // Only create order address if account and line1 are provided
          if ($utils.isAllDefined($row.cells.first_name.editControl.value, $row.cells.line1.editControl.value)) {
              const nextOrderAddressId = (await $flows.Utilities.reserve_nextId_flow({ entity: "OrderAddress" })).nextId;
  
              const firstName = $row.cells.first_name.editControl.value;
              const lastName = $row.cells.last_name.editControl.value;
  
              var payloadOrderAddress = {
                  "Id": nextOrderAddressId,
                  "Orderid": orderId,
                  "TypeId": 2,
                  "Name": firstName,
                  "FirstName": firstName,
                  "LastName": lastName,
                  "Line1": $row.cells.line1.editControl.value,
                  "Line2": $row.cells.line2.editControl.value,
                  "City": $row.cells.city.editControl.value,
                  "State": $row.cells.state.editControl.value,
                  "Country": $row.cells.country.editControl.value,
                  "PostalCode": $utils.isDefined($row.cells.zip.editControl.value) ? $row.cells.zip.editControl.value.toString() : "",
                  "PrimaryTelephone": $utils.isDefined($row.cells.phone_number.editControl.value) ? $row.cells.phone_number.editControl.value.toString() : ""
              };
  
              await $flows.Utilities.crud_create_flow({ entitySet: 'OrderAddresses', entity: payloadOrderAddress });
          }
  
          // Create order line
  
          if (orderTypeId === 1) {
              const orderLine = (await $flows.ExcelOrderImport.create_purchase_order_line_flow({
                  orderId: orderId,
                  packagedAmount: parseInt($row.cells.quantity.editControl.value, 10),
                  materialId: $row.cells.material.editControl.value,
                  packagingId: $row.cells.packaging.editControl.value,
                  shipmentId: nextShipmentId,
                  notes: $row.cells.line_notes.editControl.value
              }));
              var linenumber = orderLine.linenumber;
  
          }
  
          if (orderTypeId === 2) {
              const orderLine = (await $flows.ExcelOrderImport.create_sales_order_line_flow({
                  orderId: orderId,
                  packagedAmount: parseInt($row.cells.quantity.editControl.value, 10),
                  materialId: $row.cells.material.editControl.value,
                  packagingId: $row.cells.packaging.editControl.value,
                  shipmentId: nextShipmentId,
                  notes: $row.cells.line_notes.editControl.value
              }));
              var linenumber = orderLine.linenumber;
  
          }
  
          $row.entity.LineNumber = linenumber;
          $row.entity.OrderId = orderId;
  
  
  
          // Refresh and lock down read only cells
          $row.refresh();
  
          $row.cells.type.editControl.readOnly = true;
          $row.cells.warehouse.editControl.readOnly = true;
          $row.cells.project.editControl.readOnly = true;
  
  
  
  
  
  
  
      }
      catch (error) {
          $shell.ExcelOrderImport.showErrorDetails('Save', 'Error on save.', error);
          throw error; // to prevent displayMode 
      }
  
  }
  
  
  
  
  
  
  }
  on_vendor_lot_change(event = null) {
    return this.on_vendor_lot_changeInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_vendor_lot_changeInternal(
    $row: ExcelOrderImport_excel_portal_order_import_gridComponentRowModel,
  $grid: ExcelOrderImport_excel_portal_order_import_gridComponent, 
    $shell: ExcelOrderImport_ShellService,
    $datasources: ExcelOrderImport_DatasourceService,
    $flows: ExcelOrderImport_FlowService,
    $reports: ExcelOrderImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelOrderImport_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelOrderImport_LocalizationService,
    $event: any
  ) {
  $row.cells.lot.editControl.value = null;
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => ExcelOrderImport_receiving_shipping_dd_singleComponent),
    forwardRef(() => ExcelOrderImport_warehouses_dd_singleComponent),
    forwardRef(() => ExcelOrderImport_projects_dd_singleComponent),
    forwardRef(() => ExcelOrderImport_materials_by_project_dd_singleComponent),
    forwardRef(() => ExcelOrderImport_material_packagings_dd_singleComponent),
    forwardRef(() => ExcelOrderImport_vendorLots_dd_singleComponent),
    forwardRef(() => ExcelOrderImport_lots_dd_singleComponent),
  ],
  selector: 'ExcelOrderImport-excel_portal_order_import_grid',
  templateUrl: './ExcelOrderImport.excel_portal_order_import_grid.component.html'
})
export class ExcelOrderImport_excel_portal_order_import_gridComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IExcelOrderImport_excel_portal_order_import_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);


  inParams: IExcelOrderImport_excel_portal_order_import_gridComponentInParams = { projectId: null, warehouseId: null };


  //#region Variables
  vars: { projectId?: number } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     order_id: new GridHeaderModel(new HeaderStyles(null, null), 'OrderId', false, false, null),       line_number: new GridHeaderModel(new HeaderStyles(null, null), 'Line Number', false, false, null),       error: new GridHeaderModel(new HeaderStyles(null, null), 'Errors', false, false, null),       type: new GridHeaderModel(new HeaderStyles(null, null), 'Type', true, false, null),       vendor_reference: new GridHeaderModel(new HeaderStyles(null, null), 'Vendor reference', false, false, null),       reference: new GridHeaderModel(new HeaderStyles(null, null), 'Owner reference', false, false, null),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'Warehouse', false, false, null),       project: new GridHeaderModel(new HeaderStyles(null, null), 'Project', true, false, null),       material: new GridHeaderModel(new HeaderStyles(null, null), 'Material', true, false, null),       packaging: new GridHeaderModel(new HeaderStyles(null, null), 'Packaging', true, false, null),       quantity: new GridHeaderModel(new HeaderStyles(null, null), 'Quantity', true, false, null),       vendor_lot: new GridHeaderModel(new HeaderStyles(null, null), 'Vendor lot', false, false, null),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'Lot', false, false, null),       first_name: new GridHeaderModel(new HeaderStyles(null, null), 'First name', false, false, null),       last_name: new GridHeaderModel(new HeaderStyles(null, null), 'Last name', false, false, null),       line1: new GridHeaderModel(new HeaderStyles(null, null), 'Line1', false, false, null),       line2: new GridHeaderModel(new HeaderStyles(null, null), 'Line2', false, false, null),       city: new GridHeaderModel(new HeaderStyles(null, null), 'City', false, false, null),       state: new GridHeaderModel(new HeaderStyles(null, null), 'State', false, false, null),       zip: new GridHeaderModel(new HeaderStyles(null, null), 'Zip', false, false, null),       country: new GridHeaderModel(new HeaderStyles(null, null), 'Country', false, false, null),       phone_number: new GridHeaderModel(new HeaderStyles(null, null), 'PhoneNumber', false, false, null),       line_notes: new GridHeaderModel(new HeaderStyles(null, null), 'Line Notes', false, false, null),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: ExcelOrderImport_excel_portal_order_import_gridComponentRowModel[] = [];
  @ViewChild('$gridComponent', { read:  GridComponent}) $gridComponent: GridComponent;

  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('warehouseId') set $inParams_warehouseId(value: any) {
    this.inParams['warehouseId'] = value;
  }
  get $inParams_warehouseId(): any {
    return this.inParams['warehouseId'] ;
  }

  topToolbar = {
      linecount: new ToolModel(new ButtonModel('linecount', new ButtonStyles(null, null), true, 'LineCount', '')
    )
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };



  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    private shell: ExcelOrderImport_ShellService,
    private datasources: ExcelOrderImport_DatasourceService,
    private flows: ExcelOrderImport_FlowService,
    private reports: ExcelOrderImport_ReportService,
    private localization: ExcelOrderImport_LocalizationService,
    private operations: ExcelOrderImport_OperationService,
    ) {
    this.title = 'Portal Order Import';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
  }

  async $init() {
    const $grid = this;
    const $utils = this.utils;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  $rowPropertyChangeCallback (source: GridRowModel, property: string): void {
    if (property === 'selected') {
      this.$gridComponent.updateAllSelected();
    }
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      projectId:  $grid.vars.projectId ,
    };
    try {
    const data = await this.datasources.ExcelOrderImport.ds_order_import_grid.getList(inParams);
      this.entities = data.result;
      this.totalCount = data.totalCount;
      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.utils;
    
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new ExcelOrderImport_excel_portal_order_import_gridComponentRowModel(
          this.utils,
          this.settings,
          this.shell, 
          this.datasources,
          this.flows,
          this.reports,
          this.localization,
          this.operations);
        rowLoadPromises.push( row.$initializeExisting(this, entity, this.$rowPropertyChangeCallback.bind(this)));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  selectedRows = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    this.on_row_selected();
  }

  async addRow(entity?: IExcelOrderImport_excel_portal_order_import_gridComponentEntity) {
    const row = new ExcelOrderImport_excel_portal_order_import_gridComponentRowModel(
      this.utils,
      this.settings,
      this.shell, 
      this.datasources,
      this.flows,
      this.reports,
      this.localization,
      this.operations);
    await row.$initializeNew(this, entity, this.$rowPropertyChangeCallback.bind(this));
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_excel_export(event = null) {
    return this.on_excel_exportInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_exportInternal(
    $grid: ExcelOrderImport_excel_portal_order_import_gridComponent,
  
    $shell: ExcelOrderImport_ShellService,
    $datasources: ExcelOrderImport_DatasourceService,
    $flows: ExcelOrderImport_FlowService,
    $reports: ExcelOrderImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelOrderImport_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelOrderImport_LocalizationService,
    $event: any
  ) {
  const wb = $event;
  
  const orderLines = [];
  let warehouse = 'Required';
  let project = 'Required';
  
  if ($utils.isDefined($grid.inParams.warehouseId)) {
      const warehouseData = (await $datasources.ExcelOrderImport.ds_get_warehouse_by_warehouseId.get({ warehouseId: $grid.inParams.warehouseId })).result;
      if ($utils.isDefined(warehouseData)) {
          warehouse = warehouseData.Name;
      }
  }
  
  if ($utils.isDefined($grid.inParams.projectId)) {
      const projectData = (await $datasources.ExcelOrderImport.ds_get_project_by_projectId.get({ projectId: $grid.inParams.projectId })).result;
      if ($utils.isDefined(projectData)) {
          project = projectData.LookupCode;
      }
  }
  
  orderLines.push({
      Type: 'Receiving or Shipping',
      VendorReference: '',
      OwnerReference: '',
      Warehouse: warehouse,
      ProjectLookupCode: project,
      MaterialLookupCode: 'Required',
      VendorLotLookupCode: '',
      LotLookupCode: '',
      Packaging: 'EA, CS, etc.',
      Quantity: 'Required',
      FirstName: '',
      LastName: '',
      Line1: '',
      Line2: '',
      City: '',
      State: '',
      Zip: '',
      Country: '',
      PhoneNumber: '',
      LineNotes: ''
  
  });
  
  
  const ws = $utils.excel.json_to_sheet(orderLines);
  
  $utils.excel.book_append_sheet(wb, ws, 'OrderImport');
  
  
  
  }
  on_excel_import(event = null) {
    return this.on_excel_importInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_importInternal(
    $grid: ExcelOrderImport_excel_portal_order_import_gridComponent,
  
    $shell: ExcelOrderImport_ShellService,
    $datasources: ExcelOrderImport_DatasourceService,
    $flows: ExcelOrderImport_FlowService,
    $reports: ExcelOrderImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelOrderImport_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelOrderImport_LocalizationService,
    $event: any
  ) {
  //02/08/2024 - Added Lots/Vendor Lots - O.Arias
  //02/14/2024 - Fixed issue with empty addresses
  //02/14/2024 - Added data to the account/contact/address creation
  
  const wb = $event;
  const wsname = wb.SheetNames[0];
  const ws = wb.Sheets[wsname];
  
  $grid.topToolbar.linecount.hidden = false;
  $grid.topToolbar.linecount.control.icon = "icon ms-Icon ms-Icon--ProgressRingDots";
  $grid.topToolbar.linecount.control.label = 'Extracting Data..';
  
  const OrderLines = $utils.excel.sheet_to_json<{
      Type: string,
      VendorReference: string,
      OwnerReference: string,
      Warehouse: string,
      ProjectLookupCode: string,
      MaterialLookupCode: string,
      LotLookupCode: string,
      VendorLotLookupCode: string,
      Packaging: string,
      Quantity: number,
      FirstName: string,
      LastName: string,
      Line1: string,
      Line2: string,
      City: string,
      State: string,
      Zip: string,
      Country: string,
      PhoneNumber: string,
      LineNotes: string
  
  }>(ws);
  
  $grid.topToolbar.linecount.control.label = 'Preparing Data...';
  
  // Initialize grid and data
  //const candidates: { row?: typeof $grid.rows[0], errors?: string }[] = [];
  const candidates = [];
  var linecount = 0;
  var confirmLineCount = 0;
  var orderCheckLineCount = 0;
  var totalLineCount = OrderLines.length;
  
  if (totalLineCount > 100) {
      $grid.topToolbar.linecount.hidden = true;
      throw new Error('Excel file cannot exceed 100 rows, please break file into smaller groups of order lines.')
  };
  
  var projectsLookupCode = OrderLines.filter(ol => $utils.isDefinedTrimmed(ol.ProjectLookupCode?.toString())).map(ol => ol.ProjectLookupCode?.toString());
  var orderTypes = OrderLines.filter(ol => $utils.isDefinedTrimmed(ol.Type?.toString())).map(ol => ol.Type?.toString());
  var warehousesName = OrderLines.filter(ol => $utils.isDefinedTrimmed(ol.Warehouse?.toString())).map(ol => ol.Warehouse?.toString());
  var materialsLookupCode = OrderLines.filter(ol => $utils.isDefinedTrimmed(ol.MaterialLookupCode?.toString())).map(ol => ol.MaterialLookupCode?.toString());
  var lotsLookupCode = OrderLines.filter(ol => $utils.isDefinedTrimmed(ol.LotLookupCode?.toString())).map(ol => ol.LotLookupCode?.toString());
  var vendorLotsLookupCode = OrderLines.filter(ol => $utils.isDefinedTrimmed(ol.VendorLotLookupCode?.toString()) || $utils.isDefinedTrimmed(ol.LotLookupCode?.toString())).map(ol => ol.VendorLotLookupCode?.toString() ?? ol.LotLookupCode?.toString());
  var materialPackagings = OrderLines.filter(ol => $utils.isDefinedTrimmed(ol.Packaging?.toString())).map(ol => ol.Packaging?.toString());
  var po = OrderLines.filter(ol => $utils.isDefinedTrimmed(ol.VendorReference?.toString())).map(ol => ol.VendorReference?.toString());
  var reference = OrderLines.filter(ol => $utils.isDefinedTrimmed(ol.OwnerReference?.toString())).map(ol => ol.OwnerReference?.toString());
  
  projectsLookupCode = projectsLookupCode.filter((value, index, array) => array.indexOf(value) === index); //Distinct
  orderTypes = orderTypes.filter((value, index, array) => array.indexOf(value) === index); //Distinct
  warehousesName = warehousesName.filter((value, index, array) => array.indexOf(value) === index); //Distinct
  materialsLookupCode = materialsLookupCode.filter((value, index, array) => array.indexOf(value) === index); //Distinct
  lotsLookupCode = lotsLookupCode.filter((value, index, array) => array.indexOf(value) === index); //Distinct
  vendorLotsLookupCode = vendorLotsLookupCode.filter((value, index, array) => array.indexOf(value) === index); //Distinct
  po = po.filter((value, index, array) => array.indexOf(value) === index); //Distinct
  reference = reference.filter((value, index, array) => array.indexOf(value) === index); //Distinct
  
  var packagingMaterialsProjects = (await $datasources.ExcelOrderImport.ds_get_packagings_by_materials_projects_packagings.get({
      materialPackagings: materialPackagings,
      materialLookupcodes: materialsLookupCode,
      projectLookupcodes: projectsLookupCode
  })).result;
  
  
  var warehouses = (await $datasources.ExcelOrderImport.ds_get_warehouses_by_names.get({
      warehouseNames: warehousesName
  })).result;
  
  if ($utils.isDefined(lotsLookupCode)) {
      var lotsMaterialsProjects = (await $datasources.ExcelOrderImport.ds_get_lots_by_materials_projects_lots.get({
          lotLookupcodes: lotsLookupCode,
          materialLookupcodes: materialsLookupCode,
          projectLookupcodes: projectsLookupCode
      })).result;
  };
  
  if ($utils.isDefined(vendorLotsLookupCode)) {
      var vendorLotsMaterialsProjects = (await $datasources.ExcelOrderImport.ds_get_vendorlots_by_materials_projects_vendorlots.get({
          vendorLotLookupcodes: vendorLotsLookupCode,
          materialLookupcodes: materialsLookupCode,
          projectLookupcodes: projectsLookupCode
      })).result;
  };
  
  var created_lots: { material_id: number, vendor_lot_id: number, lookup_code: string, id: number }[] = [];
  var created_vendor_lots: { material_id: number, lookup_code: string, id: number }[] = [];
  
  for (const OrderLine of OrderLines) {
  
      linecount = linecount + 1;
      $grid.topToolbar.linecount.control.label = 'Validating Line ' + linecount.toString() + ' of ' + totalLineCount.toString();
  
      var errors = '';
  
      // Add row to grid
      const row = await $grid.addRow({
      });
  
      if ($utils.isDefined(OrderLine.VendorReference)) {
          row.cells.vendor_reference.editControl.value = OrderLine.VendorReference.toString();
      };
      if ($utils.isDefined(OrderLine.OwnerReference)) {
          row.cells.reference.editControl.value = OrderLine.OwnerReference.toString();
      };
      if ($utils.isDefined(OrderLine.LineNotes)) {
          row.cells.line_notes.editControl.value = OrderLine.LineNotes.toString();
      };
  
      if ($utils.isDefined(OrderLine.Type)) {
          if (OrderLine.Type == `Receiving`) {
              var orderTypeId = 1;
              row.cells.type.editControl.value = orderTypeId;
  
          }
          else if (OrderLine.Type = `Shipping`) {
              var orderTypeId = 2;
              row.cells.type.editControl.value = orderTypeId;
          }
          else {
              errors += 'Invalid type provided' + ' : ';
          };
      };
  
      if ($utils.isAllDefined(OrderLine.Packaging, OrderLine.MaterialLookupCode, OrderLine.ProjectLookupCode)) {
          const packagingMaterialProjectFound = packagingMaterialsProjects.find(
              p => p.Packaging.ShortName === OrderLine.Packaging
                  && p.Material.LookupCode === OrderLine.MaterialLookupCode.toString()
                  && p.Material.Project.LookupCode === OrderLine.ProjectLookupCode
          );
          if ($utils.isDefined(packagingMaterialProjectFound)) {
              var packagingId = packagingMaterialProjectFound.PackagingId;
              var materialId = packagingMaterialProjectFound.MaterialId;
              var projectId = packagingMaterialProjectFound.Material.Project.Id;
              var controllerTypeId = packagingMaterialProjectFound.Material.ControllerTypeId;
              row.cells.packaging.editControl.value = packagingId;
              row.cells.material.editControl.value = materialId;
              row.cells.project.editControl.value = projectId;
          } else {
              row.cells.packaging.editControl.value = null;
              row.cells.material.editControl.value = null;
              row.cells.project.editControl.value = null;
  
              errors += 'Packaging '
                  + OrderLine.Packaging
                  + ', material '
                  + OrderLine.MaterialLookupCode
                  + ' and or project '
                  + OrderLine.ProjectLookupCode
                  + ' could not be identified' + ' : ';
              row.cells.packaging.editControl.readOnly = false;
              row.cells.material.editControl.readOnly = false;
              row.cells.project.editControl.readOnly = false;
          };
  
          //Wavelength Development 153249: Excel Order Import - Add support for Lot and Vendor Lot creation
          /* LOT CREATION START - LOT CREATION START - LOT CREATION START - LOT CREATION START */
          if (controllerTypeId === 2 || controllerTypeId === 4) {
  
              if ($utils.isDefined(OrderLine.VendorLotLookupCode) || $utils.isDefined(OrderLine.LotLookupCode)) {
  
                  if (!$utils.isDefined(OrderLine.VendorLotLookupCode)) {
                      OrderLine.VendorLotLookupCode = OrderLine.LotLookupCode;
                  };
  
                  var lotId: number;
                  var vendorLotId: number;
  
                  var vendorLot_create: boolean = false;
                  var lot_create: boolean = false;
  
                  //Reset the variables after each loop
                  lotId = null;
                  vendorLotId = null;
  
                  if ($utils.isDefined(OrderLine.VendorLotLookupCode)) {
  
                      const vendorLotFound = vendorLotsMaterialsProjects.find(
                          v => v.LookupCode === OrderLine.VendorLotLookupCode.toString()
                              && v.Material.LookupCode === OrderLine.MaterialLookupCode.toString()
                              && v.Material.Project.LookupCode === OrderLine.ProjectLookupCode.toString()
                      );
  
                      if ($utils.isDefined(vendorLotFound)) {
                          vendorLotId = vendorLotFound.Id
                          row.cells.vendor_lot.editControl.value = vendorLotId;
                      } else {
                          vendorLot_create = true;
                          if (orderTypeId === 2) {
                              errors += `Vendor lot ${OrderLine.VendorLotLookupCode} for material ${OrderLine.MaterialLookupCode} could not be found!`
                          };
                      };
                  };
  
                  if ($utils.isDefined(OrderLine.LotLookupCode)) {
                      const lotFound = lotsMaterialsProjects.find(
                          l => l.LookupCode === OrderLine.LotLookupCode.toString()
                              && l.Material.LookupCode === OrderLine.MaterialLookupCode.toString()
                              && l.Material.Project.LookupCode === OrderLine.ProjectLookupCode.toString()
                              && (l.VendorLotId === vendorLotId || !$utils.isDefined(vendorLotId))
                              && (l.VendorLot.LookupCode === OrderLine.VendorLotLookupCode?.toString() || !$utils.isDefined(OrderLine.VendorLotLookupCode))
                      );
                      if ($utils.isDefined(lotFound)) {
                          lotId = lotFound.Id
                          vendorLotId = lotFound.VendorLotId
                          row.cells.lot.editControl.value = lotId;
                          row.cells.vendor_lot.editControl.value = vendorLotId;
                          vendorLot_create = false;
                      } else {
                          lot_create = true;
                          if (orderTypeId === 2) {
                              errors += `Lot ${OrderLine.LotLookupCode} ${OrderLine.VendorLotLookupCode ? `for vendor lot ${OrderLine.VendorLotLookupCode} and` : `for`} material ${OrderLine.MaterialLookupCode} could not be found!`
                          };
                      };
                  };
  
                  if (orderTypeId === 1 && (vendorLot_create || lot_create)) {
  
                      //Create the lot & vendor lot
                      try {
                          if (vendorLot_create) {
  
                              var found_created_vendor_lot = created_vendor_lots.find(
                                  l => l.material_id === row.cells.material.editControl.value
                                      && l.lookup_code === OrderLine.VendorLotLookupCode.toString()
                              );
  
                              if ($utils.isDefined(found_created_vendor_lot)) {
  
                                  vendorLotId = found_created_vendor_lot.id;
                              } else {
  
                                  vendorLotId = (await $flows.Utilities.reserve_nextId_flow({ entity: "VendorLot" })).nextId;
  
                                  const vendor_lot = {
                                      "Id": vendorLotId,
                                      "MaterialId": row.cells.material.editControl.value,
                                      "LookupCode": OrderLine.VendorLotLookupCode.toString()
                                  };
  
                                  await $flows.Utilities.crud_create_flow({ entitySet: 'VendorLots', entity: vendor_lot });
  
                                  created_vendor_lots.push({
                                      material_id: row.cells.material.editControl.value,
                                      lookup_code: OrderLine.VendorLotLookupCode.toString(),
                                      id: vendorLotId
                                  });
                              };
                              row.cells.vendor_lot.editControl.value = vendorLotId;
                          };
  
                          if (lot_create) {
  
                              var found_created_lot = created_lots.find(
                                  l => l.material_id === row.cells.material.editControl.value
                                      && l.vendor_lot_id === row.cells.vendor_lot.editControl.value
                                      && l.lookup_code === OrderLine.LotLookupCode.toString()
                              );
  
                              if ($utils.isDefined(found_created_lot)) {
  
                                  lotId = found_created_lot.id;
                              } else {
  
                                  lotId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Lot" })).nextId;
  
                                  const lot = {
                                      "Id": lotId,
                                      "MaterialId": row.cells.material.editControl.value,
                                      "VendorLotId": row.cells.vendor_lot.editControl.value,
                                      "StatusId": 1,
                                      "TypeId": 2,
                                      "LookupCode": OrderLine.LotLookupCode.toString()
                                  };
  
                                  await $flows.Utilities.crud_create_flow({ entitySet: 'Lots', entity: lot });
  
                                  created_lots.push({
                                      vendor_lot_id: row.cells.vendor_lot.editControl.value,
                                      material_id: row.cells.material.editControl.value,
                                      lookup_code: OrderLine.LotLookupCode.toString(),
                                      id: lotId
                                  });
                              };
                              row.cells.lot.editControl.value = lotId;
                          };
                      } catch (error) {
  
                          let targetError = error;
                          while ($utils.isDefined(targetError?.error)) {
                              targetError = targetError.error;
                          };
  
                          if (!$utils.isDefined(targetError?.message)) {
                              targetError = { "message": `Uncaught exception! ${JSON.stringify(targetError)}` }
                          };
  
                          errors += targetError.message;
                      };
                  };
              };
          };
          /* LOT CREATION END - LOT CREATION END - LOT CREATION END - LOT CREATION END */
      } else {
          errors += 'Packaging, material and or project not provided' + ' : ';
          row.cells.packaging.editControl.readOnly = false;
          row.cells.material.editControl.readOnly = false;
          row.cells.project.editControl.readOnly = false;
      }
  
  
  
      if ($utils.isDefined(OrderLine.Warehouse)) {
          const warehouseFound = warehouses.find(
              w => w.Name === OrderLine.Warehouse.toString()
          );
          if ($utils.isDefined(warehouseFound)) {
              var warehouseId = warehouseFound.Id;
              row.cells.warehouse.editControl.value = warehouseId;
          }
          else {
              row.cells.warehouse.editControl.value = null;
              errors += 'Warehouse does not exist' + ' : ';
              row.cells.warehouse.editControl.readOnly = false;
          }
      } else {
          errors += 'Warehouse not provided' + ' : '
          row.cells.warehouse.editControl.readOnly = false;
      };
  
      if (!$utils.isDefined(OrderLine.Quantity)) {
          errors += 'Quantity not provided' + ' : '
      } else {
          if (parseInt(OrderLine.Quantity.toString(), 10) > 0) {
              row.cells.quantity.editControl.value = OrderLine.Quantity;
          } else {
              errors += 'Quantity not a number' + ' : '
          }
      };
  
      if ($utils.isDefined(OrderLine.FirstName)) {
          if (OrderLine.FirstName.length > 32) {
              errors += 'First name cannot exceed 32 characters' + ' : '
          }
          else {
              row.cells.first_name.editControl.value = OrderLine.FirstName;
          }
      }
      if ($utils.isDefined(OrderLine.LastName)) {
          if (OrderLine.LastName.length > 32) {
              errors += 'Last name cannot exceed 32 characters' + ' : '
          }
          else {
              row.cells.last_name.editControl.value = OrderLine.LastName;
          }
      }
      row.cells.line1.editControl.value = OrderLine.Line1;
      row.cells.line2.editControl.value = OrderLine.Line2;
      row.cells.city.editControl.value = OrderLine.City;
      row.cells.state.editControl.value = OrderLine.State;
      row.cells.zip.editControl.value = OrderLine.Zip;
      row.cells.country.editControl.value = OrderLine.Country;
      row.cells.phone_number.editControl.value = OrderLine.PhoneNumber;
  
      $grid.topToolbar.linecount.control.label = 'Validated Line ' + linecount.toString() + ' of ' + totalLineCount.toString();
  
      row.cells.error.displayControl.text = errors;
  
      candidates.push({ row: row, errors: errors });
  };
  
  $grid.topToolbar.linecount.control.label = 'Gathering Data...'
  
  var ordersCandidates = [];
  var warehousesCandidates = candidates.filter(ol => $utils.isDefinedTrimmed(ol.row.cells.warehouse.editControl.value)).map(ol => ol.row.cells.warehouse.editControl.value);
  var projectsCandidate = candidates.filter(ol => $utils.isDefinedTrimmed(ol.row.cells.project.editControl.value)).map(ol => ol.row.cells.project.editControl.value);
  var orderTypesCandidates = candidates.filter(ol => $utils.isDefinedTrimmed((ol.row.cells.type.editControl.value === 1 ? 'Inbound' : 'Outbound'))).map(ol => (ol.row.cells.type.editControl.value === 1 ? 'Inbound' : 'Outbound'));
  var poCandidates = candidates.filter(ol => $utils.isDefinedTrimmed(ol.row.cells.vendor_reference.editControl.value)).map(ol => ol.row.cells.vendor_reference.editControl.value);
  var referenceCandidates = candidates.filter(ol => $utils.isDefinedTrimmed(ol.row.cells.reference.editControl.value)).map(ol => ol.row.cells.reference.editControl.value);
  
  var orders = (await $datasources.ExcelOrderImport.ds_get_orders_by_lookupcodes_types_projects_warehouses.get({
      orderLookupcodes: ordersCandidates,
      orderTypes: orderTypesCandidates,
      projectIds: projectsCandidate,
      warehouseIds: warehousesCandidates,
      ownerReferences: referenceCandidates
  })).result;
  
  
  $grid.topToolbar.linecount.control.label = 'Updating Grid...'
  var totalConfirmLineCount = candidates.length;
  for (const candidate of candidates) {
      const noErrors = candidate.errors === '';
      if (noErrors) {
  
          orderCheckLineCount = orderCheckLineCount + 1;
          $grid.topToolbar.linecount.control.label = 'Checking Order Status ' + orderCheckLineCount.toString() + ' of ' + totalConfirmLineCount.toString();
  
          var orderId;
  
          const orderFound = orders.find(
              o => o.LookupCode === o.LookupCode
                  && o.OrderClass.OrderType.Name === (candidate.row.cells.type.editControl.value === 1 ? 'Inbound' : 'Outbound')
                  && o.ProjectId === candidate.row.cells.project.editControl.value
                  && o.PreferredWarehouseId === candidate.row.cells.warehouse.editControl.value
                  && o.OwnerReference === ($utils.isDefined(candidate.row.cells.reference.editControl.value) ? candidate.row.cells.reference.editControl.value : o.OwnerReference)
          );
          if ($utils.isDefined(orderFound)) {
              candidate.row.entity.OrderId = orderFound.Id;
              candidate.row.entity.ShipmentId = orderFound.ShipmentOrderLookups[0].ShipmentId;
          } else {
              $grid.topToolbar.linecount.control.label = 'Creating New Order ' + orderCheckLineCount.toString() + ' of ' + totalConfirmLineCount.toString();
              orderId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Order" })).nextId;
              const nextShipmentId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Shipment" })).nextId;
              const nextAccountId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Account" })).nextId;
              const nextContactId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Contact" })).nextId;
              const nextAddressId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Address" })).nextId;
  
              //Wavelength Development 153603: Excel Order Import - Add Creation of Account/Contact/Address for Order Header
              const FirstName: string = (candidate.row.cells.first_name.editControl.value)?.toString() ?? '';
              const LastName: string = (candidate.row.cells.last_name.editControl.value)?.toString() ?? '';
              const Line1: string = (candidate.row.cells.line1.editControl.value)?.toString() ?? '';
              const Line2: string = (candidate.row.cells.line2.editControl.value)?.toString() ?? '';
              const City: string = (candidate.row.cells.city.editControl.value)?.toString() ?? '';
              const State: string = (candidate.row.cells.state.editControl.value)?.toString() ?? '';
              const Zip: string = (candidate.row.cells.zip.editControl.value)?.toString() ?? '';
              const Country: string = (candidate.row.cells.country.editControl.value)?.toString() ?? '';
              const PhoneNumber: string = (candidate.row.cells.phone_number.editControl.value)?.toString() ?? '';
  
              var LookupCode: string = "";
  
              if (FirstName !== "" || LastName !== "") {
                  LookupCode = (`${FirstName} ${LastName}`).trim();
              };
  
              if (LookupCode === "") {
                  LookupCode = "ord-" + orderId;
              };
  
              const payloadAccount = {
                  "Id": nextAccountId,
                  "EnterpriseId": 1,
                  "TypeId": 4,
                  "LookupCode": LookupCode,
                  "Name": LookupCode,
                  "Active": true,
                  "AllocationPriority": 0,
                  "AllowReceiving": false,
                  "AllowShipping": false,
                  "AllowReturnsIn": false,
                  "RequiresReceivingRma": false,
                  "TaxScheduleId": 0,
                  "RequiresShippingRma": false
              };
  
              const payloadContacts = {
                  "Id": nextContactId,
                  "OwnerEntity": "Account",
                  "OwnerId": nextAccountId,
                  "TypeId": 2,
                  "Address": {
                      "Id": nextAddressId,
                      "Line1": (Line1 !== "") ? Line1 : LookupCode,
                      "Line2": Line2,
                      "City": City,
                      "State": State,
                      "PostalCode": Zip,
                      "Country": Country
                  },
                  "FirstName": (FirstName !== "") ? FirstName : LookupCode,
                  "LastName": (LastName !== "") ? LastName : LookupCode,
                  "PrimaryTelephone": PhoneNumber
              };
  
              const shipmentpayload = {
                  "Order": {
                      "Id": orderId,
                      "LookupCode": orderId.toString(),
                      "OrderStatusId": 1,
                      "ReadyToExport": false,
                      "AccountId": nextAccountId,
                      "BillingAddresId": nextAddressId,
                      "Exported": false,
                      "OrderClassId": candidate.row.cells.type.editControl.value,
                      "ProjectId": candidate.row.cells.project.editControl.value,
                      "PreferredWarehouseId": candidate.row.cells.warehouse.editControl.value,
                      "OwnerReference": candidate.row.cells.reference.editControl.value,
                      "VendorReference": candidate.row.cells.vendor_reference.editControl.value
                  },
                  "Shipment": {
                      "Id": nextShipmentId,
                      "LookupCode": orderId.toString(),
                      "AccountId": nextAccountId,
                      "ContactId": nextContactId,
                      "ExpectedWarehouseId": candidate.row.cells.warehouse.editControl.value,
                      "Cartonized": false,
                      "ConfirmSeal": false,
                      "StatusId": 1,
                      "Transhipment": false,
                      "TypeId": candidate.row.cells.type.editControl.value
                  }
              };
  
              await $flows.Utilities.crud_create_flow({ entitySet: 'Accounts', entity: payloadAccount });
              await $flows.Utilities.crud_create_flow({ entitySet: 'Contacts', entity: payloadContacts });
              await $flows.Utilities.crud_create_flow({ entitySet: 'ShipmentOrderLookup', entity: shipmentpayload });
  
              // Only create order address if first name and line1 are provided
              if ($utils.isAllDefined(candidate.row.cells.first_name.editControl.value, candidate.row.cells.line1.editControl.value)) {
                  const nextOrderAddressId = (await $flows.Utilities.reserve_nextId_flow({ entity: "OrderAddress" })).nextId;
  
                  const firstName = candidate.row.cells.first_name.editControl.value;
  
                  const lastName = candidate.row.cells.last_name.editControl.value;
  
                  var payloadOrderAddress = {
                      "Id": nextOrderAddressId,
                      "Orderid": orderId,
                      "TypeId": 2,
                      "Name": firstName,
                      "FirstName": firstName,
                      "LastName": lastName,
                      "Line1": candidate.row.cells.line1.editControl.value,
                      "Line2": candidate.row.cells.line2.editControl.value,
                      "City": candidate.row.cells.city.editControl.value,
                      "State": candidate.row.cells.state.editControl.value,
                      "Country": candidate.row.cells.country.editControl.value,
                      "PostalCode": $utils.isDefined(candidate.row.cells.zip.editControl.value) ? candidate.row.cells.zip.editControl.value.toString() : "",
                      "PrimaryTelephone": $utils.isDefined(candidate.row.cells.phone_number.editControl.value) ? candidate.row.cells.phone_number.editControl.value.toString() : ""
                  };
  
                  await $flows.Utilities.crud_create_flow({ entitySet: 'OrderAddresses', entity: payloadOrderAddress });
              }
  
              orders.push({
                  Id: orderId,
                  LookupCode:  orderId.toString(),
                  OwnerReference: ($utils.isDefined(candidate.row.cells.reference.editControl.value) ? candidate.row.cells.reference.editControl.value : ''),
                  VendorReference: ($utils.isDefined(candidate.row.cells.vendor_reference.editControl.value) ? candidate.row.cells.vendor_reference.editControl.value : ''),
                  OrderStatusId: 1,
                  PreferredWarehouseId: candidate.row.cells.warehouse.editControl.value,
                  ProjectId: candidate.row.cells.project.editControl.value,
                  OrderClass: {
                      OrderTypeId: candidate.row.cells.type.editControl.value,
                      OrderType: {
                          Name: candidate.row.cells.type.editControl.value === 1 ? 'Inbound' : 'Outbound'
                      }
                  },
                  Project: {
                      LookupCode: ''
                  },
                  ShipmentOrderLookups: [{
                      OrderId: orderId,
                      ShipmentId: nextShipmentId
                  }],
                  PreferredWarehouse: {
                      Name: ''
                  }
              });
              candidate.row.entity.OrderId = orderId;
              candidate.row.entity.ShipmentId = nextShipmentId;
          }
  
  
      }
  };
  
  for (const candidate of candidates) {
      const noErrors = candidate.errors === '';
      if (noErrors) {
  
          try {
  
              confirmLineCount = confirmLineCount + 1;
              $grid.topToolbar.linecount.control.label = 'Creating Order Line ' + confirmLineCount.toString() + ' of ' + totalConfirmLineCount.toString();
  
              // Check if inbound versus outbound to use different API
              if (candidate.row.cells.type.editControl.value === 1) {
  
                  const orderLine = (await $flows.ExcelOrderImport.create_purchase_order_line_flow({
                      orderId: candidate.row.entity.OrderId,
                      packagedAmount: parseInt(candidate.row.cells.quantity.editControl.value, 10),
                      materialId: candidate.row.cells.material.editControl.value,
                      packagingId: candidate.row.cells.packaging.editControl.value,
                      shipmentId: candidate.row.entity.ShipmentId,
                      notes: candidate.row.cells.line_notes.editControl.value,
                      lotId: candidate.row.cells.lot.editControl.value,
                      vendorlotId: candidate.row.cells.vendor_lot.editControl.value
                  }));
  
                  if (!$utils.isDefined(orderLine)) {
                      errors += 'Error calling create order line API'
                      candidate.row.cells.error.displayControl.text = errors;
                  }
                  else {
                      var linenumber = orderLine.linenumber;
                  }
  
              }
  
              if (candidate.row.cells.type.editControl.value === 2) {
                  const orderLine = (await $flows.ExcelOrderImport.create_sales_order_line_flow({
                      orderId: candidate.row.entity.OrderId,
                      packagedAmount: parseInt(candidate.row.cells.quantity.editControl.value, 10),
                      materialId: candidate.row.cells.material.editControl.value,
                      packagingId: candidate.row.cells.packaging.editControl.value,
                      shipmentId: candidate.row.entity.ShipmentId,
                      notes: candidate.row.cells.line_notes.editControl.value,
                      lotId: candidate.row.cells.lot.editControl.value,
                      vendorlotId: candidate.row.cells.vendor_lot.editControl.value
                  }));
  
                  var linenumber = orderLine.linenumber;
              }
  
              candidate.row.entity.LineNumber = linenumber;
  
              candidate.row.refresh();
              candidate.row.setDisplayMode();
              candidate.row.isNew = false;
              candidate.row.cells.type.editControl.readOnly = true;
              candidate.row.cells.warehouse.editControl.readOnly = true;
              candidate.row.cells.project.editControl.readOnly = true;
  
          } catch (error) {
              errors += 'Error calling create order line API'
              candidate.row.cells.error.displayControl.text = errors;
              $grid.topToolbar.linecount.hidden = true;
              throw error; // to prevent displayMode 
          }
      }
  }
  
  $grid.topToolbar.linecount.hidden = true;
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: ExcelOrderImport_excel_portal_order_import_gridComponent,
  
    $shell: ExcelOrderImport_ShellService,
    $datasources: ExcelOrderImport_DatasourceService,
    $flows: ExcelOrderImport_FlowService,
    $reports: ExcelOrderImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelOrderImport_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelOrderImport_LocalizationService,
    $event: any
  ) {
  $grid.vars.projectId = 0
  
  $grid.topToolbar.linecount.hidden = true;
  
  
  
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: ExcelOrderImport_excel_portal_order_import_gridComponent,
  
    $shell: ExcelOrderImport_ShellService,
    $datasources: ExcelOrderImport_DatasourceService,
    $flows: ExcelOrderImport_FlowService,
    $reports: ExcelOrderImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelOrderImport_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelOrderImport_LocalizationService,
    $event: any
  ) {
  
  
  const hasZeroSelectedRows = $grid.selectedRows.length === 0;
  
  
  }
  //#endregion private flows

  $importExcel(fileInput: HTMLInputElement) {
    if(fileInput.files?.length !== 1) {
      throw new Error('Cannot import multiple files');
    }
    const file = fileInput.files[0];
    if(file.size > 15 * 1000 * 1000) {
      throw new Error('Cannot import a file with size greater than 15MB');
    }
    const reader: FileReader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      const ab: ArrayBuffer = e.target?.result as ArrayBuffer;
      const wb: WorkBook = readExcelFile(ab);
      this.on_excel_import(wb);
    };
    reader.readAsArrayBuffer(file);
    fileInput.value = '';
  }

  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_excel_export(wb);

    writeExcelFile(wb, 'ExcelOrderImport_excel_portal_order_import_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
